<template>
  <b-modal
    ref="modal"
    :title="modalTitle"
    size="md"
    ok-title="Salvar"
    cancel-title="Cancelar"
    :ok-disabled="saving"
    :cancel-disabled="saving"
    @ok="onSaveClicked($event)"
    @cancel="$emit('cancel')"
  >
    <b-form>
      <b-row>
        <b-col cols="12" lg="6">
          <b-form-group label="Tipo">
            <b-form-select
              v-model="event.type"
              v-validate="rules.type"
              class="form-control"
              :options="typeOpts"
              aria-describedby="invalidType"
              name="type"
              :state="validateState('state')"
            ></b-form-select>
            <b-form-invalid-feedback id="invalidType">
              {{ errors.first("type") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col
          v-if="event.type === DSAREventType.STATUS_CHANGE"
          cols="12"
          lg="6"
        >
          <b-form-group label="Status">
            <b-form-select
              v-model="event.status"
              v-validate="rules.status"
              class="form-control"
              :options="statusOpts"
              aria-describedby="invalidStatus"
              name="status"
              :state="validateState('status')"
            ></b-form-select>
            <b-form-invalid-feedback id="invalidStatus">
              {{ errors.first("status") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row
        v-if="
          companyClassification.dsarClosure.enabled &&
          event.type === DSAREventType.STATUS_CHANGE &&
          event.status === DSARStatus.CONCLUDED
        "
      >
        <b-col>
          <b-form-group label="Indicador de Encerramento">
            <b-form-select
              v-model="event.dsarClosure"
              v-validate="rules.closure"
              class="form-control"
              :options="classificationOptions.dsarClosure"
              aria-describedby="invalidClosure"
              name="closure"
              :state="validateState('closure')"
            ></b-form-select>
            <b-form-invalid-feedback id="invalidClosure">
              {{ errors.first("closure") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="event.type === DSAREventType.WITH_ATTACHMENT">
        <b-col cols="12">
          <b-form-group
            label="Anexo"
            :state="fileValidated"
            invalid-feedback="Adicione um arquivo"
          >
            <single-file-upload
              ref="upload"
              :post-action="upload.postAction"
              :data="upload.data"
              :disabled="uploading || uploadComplete"
              @upload-complete="onProcessingFinished"
              @file-changed="validateFile()"
            >
            </single-file-upload>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Descrição">
            <b-form-textarea
              v-model="event.description"
              v-validate="rules.description"
              type="text"
              class="form-control"
              :rows="4"
              :max-rows="4"
              aria-describedby="invalidDescription"
              name="description"
              :state="validateState('description')"
            ></b-form-textarea>
            <b-form-invalid-feedback id="invalidDescription">
              {{ errors.first("description") }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-modal>
</template>

<script>
import DSARStatus from "../../../../backend/models/dsar/DSARStatus.ts";
import DSAREventType from "../../../../backend/models/dsar/DSAREventType.ts";
import { getStatusText } from "../complaints/utils";
import { createDSAREvent } from "../../api/dsar";
import SingleFileUpload from "../../components/SingleFileUpload";
import moment from "moment";
import { getCompanyUsers } from "../../api/company";
import { mapGetters } from "vuex";

export default {
  name: "DsarEventModal",
  components: { SingleFileUpload },
  props: {
    dsar: {
      type: Object,
      default: null,
    },
    pendency: {
      type: Object,
      default: null,
    },
  },
  data() {
    const classification = {
      dsarClosure: this.dsar.classification
        ? this.dsar.classification.dsarClosure
        : null,
    };

    const companyClassification = {
      dsarClosure: {},
    };
    if (
      this.dsar.company.classification &&
      this.dsar.company.classification.dsarClosure?.enabled
    ) {
      companyClassification.dsarClosure.enabled =
        this.dsar.company.classification.dsarClosure.enabled;
    } else {
      companyClassification.dsarClosure.enabled = true;
    }

    const statusOpts = [];
    for (const status of Object.keys(DSARStatus)) {
      if (status === "NEW") {
        continue;
      }

      const text = getStatusText(DSARStatus[status]);
      statusOpts.push({ value: DSARStatus[status], text });
    }

    return {
      classification,
      companyClassification,
      minDeadline: moment().format("YYYY-MM-DD"),
      DSARStatus,
      DSAREventType,
      statusOpts,
      typeOpts: [],
      event: {
        type: DSAREventType.FREE_TEXT,
        pendency: { user: null },
        status: null,
      },
      uploading: false,
      uploadComplete: false,
      fileValidated: true,
      companyUsers: [],
      managedByCompanyUsers: [],
      userOpts: [],
      upload: {
        postAction: "",
        data: {},
      },
      saving: false,
    };
  },
  computed: {
    ...mapGetters(["profile", "classificationOptions"]),
    modalTitle() {
      if (this.pendency) {
        return `Resolução de pendência da movimentação #${this.pendency.number}`;
      }
      return "Adicionar Movimentação";
    },
    rules() {
      return {
        type: { required: true },
        description: { required: true },
        status: { required: this.event.type === DSAREventType.STATUS_CHANGE },
        closure: {
          required:
            this.event.type === DSAREventType.STATUS_CHANGE &&
            this.event.status === DSARStatus.CONCLUDED,
        },
        pendency: {
          user: {
            required: !!this.event.pendency.dueDate,
          },
          dueDate: {
            required: false,
          },
        },
      };
    },
  },
  methods: {
    validateState(ref) {
      if (
        this.vFields[ref] &&
        (this.vFields[ref].dirty || this.vFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },

    validateFile() {
      if (this.event.type === DSAREventType.WITH_ATTACHMENT) {
        const file = this.$refs.upload.selectedFile();
        this.fileValidated = !!file;
      }
    },
    async onSaveClicked(bvEvt) {
      bvEvt.preventDefault();
      if (this.saving) {
        return;
      }
      this.saving = true;
      await this.processSave();
    },
    async processSave() {
      const validated = await this.$validator.validateAll();
      this.validateFile();

      if (!validated || !this.fileValidated) {
        return;
      }

      let response;
      try {
        response = await createDSAREvent(this.dsar._id, this.event);
      } catch (error) {
        console.debug(error);
        if (error.response.status === 403 || error.response.status === 404) {
          this.$bvToast.toast(error.response.data, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        } else {
          this.$bvToast.toast(error.response.statusText, {
            title: "Erro",
            toastClass: "custom-toast custom-toast-error",
            variant: "light",
            solid: true,
            autoHideDelay: 10000,
            noCloseButton: false,
          });
        }
        return;
      }

      if (this.event.type === DSAREventType.WITH_ATTACHMENT) {
        const event = response.data;
        this.uploading = true;

        const file = this.$refs.upload.selectedFile();

        this.upload.postAction = `/api/dsar/${this.dsar._id}/events/${event._id}/file`;
        file.postAction = this.upload.postAction;
        file.headers = this.upload.headers;

        this.$nextTick(() => this.$refs.upload.start());
      } else {
        this.onProcessingFinished();
      }
    },

    onProcessingFinished() {
      this.uploadComplete = true;
      this.uploading = false;

      this.$bvToast.toast("Evento criado com sucesso!", {
        title: "Sucesso",
        toastClass: "custom-toast custom-toast-success",
        variant: "light",
        solid: true,
        autoHideDelay: 5000,
        noCloseButton: false,
      });
      this.$emit("new-event");

      if (this.event.type === DSAREventType.STATUS_CHANGE) {
        this.$emit("status-changed", this.event.status);
      }

      if (this.pendency) {
        this.$emit("status-changed", DSARStatus.PROCESSING);
      }

      this.$refs.modal.hide();
      this.saving = false;
    },

    async loadUserOpts() {
      const response = await getCompanyUsers(this.dsar.company._id, true);
      this.companyUsers = response.data;
      if (this.dsar.company.managedBy) {
        this.managedByCompanyUsers = (
          await getCompanyUsers(this.dsar.company.managedBy, true)
        ).data;
      }
      const userOpts = [];

      const getUserName = (id) => {
        let user = this.companyUsers.find((e) => e._id === id);
        if (user) {
          return `${user.name} ${user.surname}`;
        }
        user = this.managedByCompanyUsers.find((e) => e._id === id);
        return `${user.name} ${user.surname}`;
      };
      const myId = this.profile._id;
      let addedSelf = false;
      if (!addedSelf && !!this.profile.company) {
        userOpts.unshift({ value: myId, text: getUserName(myId) });
      }
      userOpts.unshift({ value: null, text: "" });
      this.userOpts = userOpts;
    },

    async show() {
      await this.loadUserOpts();
      this.event = {
        type: 1,
        pendency: { user: null },
      };
      if (this.pendency) {
        this.event.pendency.resolves = this.pendency._id;
      }
      const typeOpts = [
        { value: DSAREventType.FREE_TEXT, text: "Texto livre" },
        { value: DSAREventType.WITH_ATTACHMENT, text: "Com anexo" },
      ];
      if (!this.pendency) {
        typeOpts.push({
          value: DSAREventType.STATUS_CHANGE,
          text: "Mudança de Status",
        });
      }
      this.typeOpts = typeOpts;
      this.$refs.modal.show();
    },
  },
};
</script>
